module.exports = __webpack_public_path__ + "static/img/Mb331.2cc6358.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Mb331.jpg
// module id = buiV
// module chunks = 1